import { Button, Col, Form, InputNumber, Input, Row, FormInstance } from "antd";
import Boleto from "../../../../../../Models/Financeiro/Titulo/Pagamento/Boleto";
import ContaSelect from "../../../Conta/ContaSelect";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";

interface IBoletoFormBasicProps {
    form:FormInstance<T>,
    nameBase:string[],
    namePath:string[]
}
export default function BoletoFormBasic({
    form,
    nameBase,
    namePath
}:IBoletoFormBasicProps) {
    return <>
        {/* 
        Agora conta está no pagamento
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Boleto> label="Conta" name={[...nameBase, "codConta"]} rules={[ { required : true } ]}>
                <ContaSelect filtros={{
                    encerrada : false,
                    codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                }} />
            </Form.Item>
        </Col> */}
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Boleto> label="Nº Remessa" name={[...nameBase, "numeroArquvoRemessa"]} rules={[ { required : true } ]}>
                <InputNumber<number>
                    style={{ width: "100%" }} 
                    min={1} 
                    precision={0}
                    controls={true} 
                    placeholder="Nº Remessa" 
                    addonBefore={<>Nº</>}
                />
            </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Boleto> label="Nº documento" name={[...nameBase, "documento"]} rules={[ { required : true } ]}>
                <InputNumber<number>
                    style={{ width: "100%" }} 
                    min={1} 
                    precision={0}
                    controls={true} 
                    placeholder="Nº documento" 
                    addonBefore={<>Nº</>}
                />
            </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Boleto> label="Nosso número" name={[...nameBase, "nossoNumero"]} rules={[ { required : true } ]}>
                <InputNumber<number>
                    style={{ width: "100%" }} 
                    min={1} 
                    precision={0}
                    controls={true} 
                    placeholder="Nosso número" 
                    addonBefore={<>Nº</>}
                />
            </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Credito>
                label="Nº banco"
                name={[...nameBase, "nossoNumeroBanco"]}
                rules={[{ required: true, max: 32 }]}
            >
                <Input maxLength={32} placeholder="Nº banco" style={{ width: "100%" }} />
            </Form.Item>
        </Col>
    </>
}